// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__qDGz0","btn":"style_btn__Q7cP7","back_button":"style_back_button__1+kX5"};